module.exports = __webpack_public_path__ + "static/media/upload1.99834a2b.png";